export default __webpack_public_path__ + "static/media/prize funds new.b3397048.png";